//路由常量
// const TO_ABOUT_US="TO_ABOUT_US"; //关于我们
// const TO_FEATURE_SERVICE="TO_FEATURE_SERVICE";
// const TO_PROJECT_EXAMPLE="TO_PROJECT_EXAMPLE";
// const TO_PARTENER="TO_PARTENER";
// const TO_CHAIRMAN_SPEAK="TO_CHAIRMAN_SPEAK";
// const TO_HONOR="TO_HONOR";
// const TO_MEMORABILIA="TO_MEMORABILIA"; //经纬大事记
// const TO_COMMENT="TO_COMMENT"; //留言评论
const TO_URL="TO_URL";

//api请求常量
const FETCH_JW_LIST="FETCH_JW_LIST";
const FETCH_JW_DEATIL="FETCH_JW_DEATIL";
const FETCH_PARTNER_NEWS_DETAIL="FETCH_PARTNER_NEWS_DETAIL";
const FETCH_JW_ZXZX="FETCH_JW_ZXZX";

const ActionType={
    TO_URL,

    //请求api的action
    FETCH_JW_LIST,
    FETCH_JW_DEATIL,
    FETCH_PARTNER_NEWS_DETAIL,
    FETCH_JW_ZXZX,
}

export default ActionType;